import React, { useState, createContext } from 'react';
import { string, oneOfType, arrayOf, element, node, object } from 'prop-types';
import SymbolWrapper from './symbolWrapper';
export const IconContext = /*#__PURE__*/createContext();
const {
  Provider
} = IconContext;

const IconProvider = ({
  children,
  logger = console
}) => {
  const [icons, setIcons] = useState({});

  const addIconSymbol = (name, icon) => {
    setIcons(prev => Object.assign({}, prev, {
      [name]: Object.assign({}, icon, {
        viewBox: (icon == null ? void 0 : icon.viewBox) || '0 0 24 24'
      })
    }));
    return icon.name;
  };

  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      addIconSymbol,
      icons,
      logger
    }
  }, /*#__PURE__*/React.createElement(SymbolWrapper, {
    icons: icons
  }), children);
};

IconProvider.defaultProps = {
  children: null
};
process.env.NODE_ENV !== "production" ? IconProvider.propTypes = {
  children: oneOfType([element, string, arrayOf(element), node]),
  logger: object
} : void 0;
export default IconProvider;